import { Box, Stack, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const HeaderCalendar = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(7, 1fr)",
}));

export const WeekDay = styled(Stack)(({ theme }) => ({
  flex: 1,
  width: "100%",
  fontSize: theme.typography.size.xs_12,
  color: theme.palette.text.textPrimary,
  fontWeight: theme.typography.fw_regular_400,
  padding: pxToRem(10),
  backgroundColor: theme.palette.background.bgBase,
  borderTop: `1px solid ${theme.palette.stroke.strokeDefault}`,
  borderRight: `1px solid ${theme.palette.stroke.strokeDefault}`,
  "&:first-child": {
    borderTopLeftRadius: pxToRem(8),
    borderLeft: `1px solid ${theme.palette.stroke.strokeDefault}`,
  },
  "&:last-child": {
    borderTopRightRadius: pxToRem(8),
  },

  [theme.breakpoints.down("sm")]: {
    minWidth: "50px",
    paddingInline: pxToRem(10),
  },
}));

export const WeekWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  boxSizing: "border-box",
  "&:last-child": {
    ".content": {
      "&:first-child": {
        borderBottomLeftRadius: pxToRem(8),
      },
      "&:last-child": {
        borderBottomRightRadius: pxToRem(8),
      },
    },
  },
}));

export const DayContent = styled(Box)(({ theme }) => ({
  flex: 1,
  borderBottom: `1px solid ${theme.palette.stroke.strokeDefault}`,
  padding: pxToRem(10),
  borderRight: `1px solid ${theme.palette.stroke.strokeDefault}`,
  "&:first-child": {
    borderLeft: `1px solid ${theme.palette.stroke.strokeDefault}`,
  },
  "&:last-child": {},
  [theme.breakpoints.down("sm")]: {
    minWidth: "50px",
  },
}));

export const Status = styled(Box)<{ dayStatus: string }>(
  ({ theme, dayStatus }) => ({
    fontSize: theme.typography.size.xs_12,
    fontWeight: theme.typography.fw_regular_400,
    color:
      dayStatus === "X"
        ? theme.palette.text.textLink
        : theme.palette.text.textPrimary,
    backgroundColor:
      dayStatus === "X"
        ? theme.palette.background.bgBrandPrimary
        : theme.palette.background.bgTertiary,
    borderRadius: pxToRem(4),
    padding: dayStatus === "outside" ? 0 : `${pxToRem(2)} ${pxToRem(8)}`,
  })
);

export const SummaryWrapper = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  // gap: pxToRem(20),

  background: theme.palette.background.bgTable,
  borderRadius: pxToRem(12),
  padding: `${pxToRem(10)} ${pxToRem(20)}`,
  overflow: "auto",
}));

export const SummaryItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderRight: `1px dashed ${theme.palette.stroke.strokeDefault}`,
  paddingBottom: pxToRem(10),
  paddingLeft: pxToRem(28),
  paddingRight: pxToRem(28),
  "&:nth-child(3n)": {
    borderRight: "none",
    paddingRight: 0,
  },
  "&:nth-child(3n+1)": {
    paddingLeft: 0,
  },
  "&:nth-child(1)": {
    ".summary-content": {
      borderTop: "none",
    },
  },
  "&:nth-child(2)": {
    ".summary-content": {
      borderTop: "none",
    },
  },
  "&:nth-child(3)": {
    ".summary-content": {
      borderTop: "none",
    },
  },

  [theme.breakpoints.down("sm")]: {
    alignItems: "flex-start",
    fontSize: theme.typography.size.xs_12,
  },
}));

export const SummaryContent = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  gap: pxToRem(8),
  borderTop: `1px solid ${theme.palette.stroke.strokeDefault2}`,
  paddingTop: pxToRem(10),
}));

export const SummaryCount = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: `${pxToRem(16)} ${pxToRem(20)}`,
  background: theme.palette.background.bgBrandPrimary,
  borderRadius: `${pxToRem(2)} ${pxToRem(8)} ${pxToRem(8)} ${pxToRem(2)}`,
  borderLeft: `2px solid ${theme.palette.stroke.strokeBrand}`,
}));
